import { LoaderCircleIcon } from "lucide-react";

export default function LoadingAnimation() {
    return (
        <div className="flex h-full w-full flex-col items-center justify-center">
            <LoaderCircleIcon className="animate-spin duration-500" size={48} />
        </div>
    );
}
